import React, { useState, memo } from 'react';
import { Plus, ArrowLeft } from 'lucide-react';
import MemoryCard from '../components/MemoryCard';
import JournalEntry from '../components/JournalEntry';
import MemoryPrompts from '../components/MemoryPrompts';
const Memory = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [view, setView] = useState<'memories' | 'prompts'>('memories');
  const memories = [{
    id: 1,
    imageUrl: 'https://images.unsplash.com/photo-1601581875039-e899893d520c',
    title: "My grandson's birthday party",
    date: 'April 15, 2023',
    hasAudio: true,
    preview: 'It was such a wonderful day. Tommy loved his new bicycle...'
  }, {
    id: 2,
    title: "Recipe for Mary's apple pie",
    date: 'March 22, 2023',
    hasAudio: true,
    hasDrawing: true,
    preview: 'The secret is adding a pinch of cinnamon and using Granny Smith apples...'
  }, {
    id: 3,
    imageUrl: 'https://images.unsplash.com/photo-1609220136736-443140cffec6',
    title: 'Visit to the botanical garden',
    date: 'February 10, 2023',
    preview: "The roses were in full bloom. It reminded me of my mother's garden..."
  }];
  if (isCreating) {
    return <div className="py-6" data-id="element-438">
        <button onClick={() => setIsCreating(false)} className="flex items-center text-lg text-gray-600 dark:text-gray-300 mb-6" data-id="element-439">
          <ArrowLeft className="w-6 h-6 mr-2" data-id="element-440" />
          Back to Memories
        </button>
        <JournalEntry onSave={() => setIsCreating(false)} data-id="element-441" />
      </div>;
  }
  return <div className="py-6" data-id="element-442">
      <div className="flex items-center justify-between mb-6" data-id="element-443">
        <div data-id="element-444">
          <h1 className="text-2xl font-bold dark:text-white" data-id="element-445">My Journal</h1>
          <p className="text-gray-600 dark:text-gray-300 mt-1" data-id="element-446">
            Capture your special moments
          </p>
        </div>
        <button onClick={() => setIsCreating(true)} className="btn btn-primary" aria-label="Create new memory" data-id="element-447">
          <Plus className="w-6 h-6 mr-2" data-id="element-448" />
          New Entry
        </button>
      </div>
      {/* View Toggle */}
      <div className="flex gap-2 mb-6 bg-gray-50 dark:bg-slate-800 p-1 rounded-xl" data-id="element-449">
        <button onClick={() => setView('memories')} className={`flex-1 py-3 px-4 rounded-lg transition-all
            ${view === 'memories' ? 'bg-white dark:bg-slate-700 shadow-soft' : 'hover:bg-white/50 dark:hover:bg-slate-700/50'}`} data-id="element-450">
          My Memories
        </button>
        <button onClick={() => setView('prompts')} className={`flex-1 py-3 px-4 rounded-lg transition-all
            ${view === 'prompts' ? 'bg-white dark:bg-slate-700 shadow-soft' : 'hover:bg-white/50 dark:hover:bg-slate-700/50'}`} data-id="element-451">
          Daily Prompts
        </button>
      </div>
      {view === 'memories' ? <div className="space-y-4" data-id="element-452">
          {memories.map(memory => <MemoryCard key={memory.id} {...memory} onPlay={() => console.log('Playing audio for:', memory.title)} onEdit={() => console.log('Editing:', memory.title)} data-id="element-453" />)}
        </div> : <MemoryPrompts data-id="element-454" />}
    </div>;
};
export default Memory;